<p>
  detail works!
</p>
